const ROUTING_NUMBER_LENGTH = 9;
const ROUTING_NUMBER_CHECKSUM_MODULUS = 10;
const ROUTING_NUMBER_WEIGHTS = [3, 7, 1, 3, 7, 1, 3, 7, 1];
const SWIFT_CODE_PATTERN = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

export const ROUTING_NUMBER_ERROR =
    'Routing number (ABA) must be 9 digits and pass the ABA checksum.';
export const SWIFT_CODE_ERROR =
    'SWIFT / BIC must be 8 or 11 characters: 4-letter bank code, 2-letter country code, ' +
    'then 2 (or 5) letters or digits.';

const normalize = (value?: string) => (value ?? '').replace(/[\s-]/g, '');

export const isRoutingNumberValid = (routingNumber?: string): boolean => {
    const digits = normalize(routingNumber);
    if (digits.length === 0) {
        return true;
    }
    if (digits.length !== ROUTING_NUMBER_LENGTH || !/^\d+$/.test(digits)) {
        return false;
    }
    const checksum = digits
        .split('')
        .reduce((total, digit, index) => total + Number(digit) * ROUTING_NUMBER_WEIGHTS[index], 0);
    return checksum % ROUTING_NUMBER_CHECKSUM_MODULUS === 0;
};

export const isSwiftCodeValid = (swiftCode?: string): boolean => {
    const code = normalize(swiftCode).toUpperCase();
    return code.length === 0 || SWIFT_CODE_PATTERN.test(code);
};
